import { ACTION_GET_LIST_APPS, ACTION_GET_LIST_APPS_ERROR, ACTION_GET_LIST_APPS_SUCCESS } from "../actions";
const initState = {
    isLoading: false,
    erro_msg: undefined,
    data: undefined
}


export const getAppListsReducer = (state = initState, action = {}) => {
    switch (action.type) {
        case ACTION_GET_LIST_APPS:
            return { ...state, isLoading: true, erro_msg: undefined }
        case ACTION_GET_LIST_APPS_SUCCESS:
            return { ...state, isLoading: false, erro_msg: undefined, data: action.payload.data }
        case ACTION_GET_LIST_APPS_ERROR:
            return { ...state, isLoading: false, erro_msg: action.payload.msg };
        default:
            return state;
    }
}